import $ from 'jquery';
import {checkWrittenAnswer, shuffleArray} from "../playUtil.es6";
import PlayAudio from "../memo/playAudio.es6";

require('jsrender')($);

const SET_TMPL = $.templates(`
<div class="pack-test-set">
    <div class="col pack-test-set__title">{{>~l18n.get('packTest.qsWritten')}}</div>
    <div class="pack-test-set__written">
        <div class="pack-test-set__written-questions">
            <ul>
            {{for questions}}
                <li class="pack-test-set__written-question" data-id="{{:id}}">
                    <div class="row no-gutters">
                        {{if question.audio}}
                        <div class="col-auto mr-3">
                            <audio src="{{attr:question.audio}}"></audio>
                            <a class="btn btn-light" data-handler="playAudio"><span class="fal fa-volume"></span></a>
                        </div>
                        {{/if}}
                        {{if question.image}}<div class="col-auto mr-3 pack-test-set__yn-image"><img src="{{attr:question.image}}"/></div>{{/if}}
                        <div class="col pack-test-set__written-question-text fl-tt-{{:question.textType}}">{{if question.textType == 'html'}}{{:question.text}}{{else}}{{> question.text}}{{/if}}</div>
                    </div>
                    <input type="text" class="form-control fl-form-control" placeholder="{{attr:~l18n.get('packTest.qsWritten.inputPlaceholder')}}">
                </li>
            {{/for}}
            </ul>
        </div>
    </div>
</div>`);
const ANSWER_TMPL = $.templates(`
<span class="pack-test-set__written-question-expected fl-keep-nl">{{>~l18n.get('packTest.qsWritten.expected')}} {{>expected.textOnly}}.</span>        
`);

export default class TestWritten {
    constructor(props) {
        this.testList = props.testList;
        this.sideAdapter = props.sideAdapter;
        this.l18n = props.l18n;
        this.checkers = props.checkers;
        this.test = props.test;
        this.cards = props.cards;
        this.oneAnswerRequire = props.oneAnswerRequire;
    }

    create(tasks) {
        const texts = this.sideAdapter;

        const questions = tasks.map(item => {
            return {id: item.id, question: texts.question(item), answer: texts.answer(item)};
        });
        shuffleArray(questions);

        const checkAnswer = this.oneAnswerRequire
            ? (expected, action) => checkWrittenAnswer(expected, action)
            : (expected, action) => checkWrittenAnswer(expected, action, true);

        questions.forEach(q => {
            this.checkers.push(() => {
                const view = this.testList.find(`.pack-test-set__written-question[data-id=${q.id}]`);
                const userInput = view.find('input[type=text]').prop('readonly', true).attr('placeholder', '');
                if (checkAnswer(q.answer.textOnly, userInput.val())) {
                    view.addClass('pack-test-set__written-question--correct');
                    this.test.correctAnswers += 1;
                } else {
                    view.addClass('pack-test-set__written-question--wrong');
                    view.append(ANSWER_TMPL.render({expected: q.answer}, this));

                    if (userInput.val() === '') {
                        userInput.remove();
                    }
                }
            });
        });

        const html = $(SET_TMPL.render({questions: questions}, this));

        html.find('a[data-handler=playAudio]').each(function (e) {
            const anchor = $(this);
            PlayAudio.initSingleSide(anchor, false, anchor.closest('div'));
        });

        this.testList.append(html);
    }
}